import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <motion.section className="pt-6 pb-8 flex flex-col items-center" variants={containerVariants} initial="hidden" animate="visible" data-id="element-60">
      {/* Hero Banner with Background Image */}
      <motion.div variants={itemVariants} className="w-full relative rounded-2xl overflow-hidden shadow-glow mb-10" data-id="element-61">
        <img src="https://cdn.magicpatterns.com/uploads/az4ZwVVbgTVEPbv9esJcgp/Gemini_Generated_Image_co3gvnco3gvnco3g.png" alt="LumiMate humanoid lamp on a desk setup" className="w-full h-[500px] sm:h-[550px] object-cover" data-id="element-62" />
        {/* Dark overlay — heavier on the left/top for text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/50 to-transparent" data-id="element-63" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/30" data-id="element-64" />

        {/* Text overlay — positioned top-left to avoid the lamp */}
        <div className="absolute inset-0 flex flex-col justify-between p-6 sm:p-10 z-10" data-id="element-65">
          <div className="max-w-md pt-2 sm:pt-4" data-id="element-66">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-white leading-tight" data-id="element-67">
              Brighten Your Space with the Companion That{' '}
              <span className="text-brand-orange drop-shadow-[0_0_15px_rgba(255,106,0,0.5)]" data-id="element-68">
                Lights Up
              </span>{' '}
              Your Best Ideas.
            </h1>
          </div>
          <div className="max-w-md pb-2 sm:pb-4" data-id="element-69">
            <p className="text-base sm:text-lg text-gray-300 leading-relaxed" data-id="element-70">
              Tired of rigid, boring desk lamps? Meet the fully articulated LED
              partner that sticks where others can't and brings personality to
              your hustle.
            </p>
          </div>
        </div>
      </motion.div>

      {/* Bullet Points */}
      <motion.div variants={itemVariants} className="w-full flex flex-col gap-4 mb-10 text-left" data-id="element-71">
        {["The world's most versatile, suction-grip LED humanoid lamp.", 'Engineered for creators, late-night students, and desk-setup enthusiasts.', "Because your workspace shouldn't just be functional—it should be inspiring."].map((bullet, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-72">
            <CheckCircle2Icon className="w-6 h-6 text-brand-orange shrink-0 mt-0.5" data-id="element-73" />
            <span className="text-brand-text font-medium" data-id="element-74">{bullet}</span>
          </div>)}
      </motion.div>

      {/* Bottom CTA */}
      <motion.button variants={itemVariants} whileHover={{
      scale: 1.03
    }} whileTap={{
      scale: 0.97
    }} onClick={() => document.getElementById('bundles')?.scrollIntoView({
      behavior: 'smooth'
    })} className="w-full py-5 px-6 bg-brand-orange text-white text-lg md:text-xl font-bold rounded-xl shadow-glow hover:shadow-glow-hover transition-all duration-300 flex items-center justify-center gap-3" data-id="element-75">
        SHOP NOW
        <ArrowRightIcon className="w-6 h-6" data-id="element-76" />
      </motion.button>
    </motion.section>;
}